var map = {
	"./activities-widget/activities-widget.js": [
		3,
		4
	],
	"./album-widget/album-widget.js": [
		4,
		5
	],
	"./banner/banner.js": [
		5,
		0,
		6
	],
	"./blocks/blocks.js": [
		6,
		7
	],
	"./content/content.js": [
		7,
		8
	],
	"./employees/employees.js": [
		8,
		9
	],
	"./events/events.js": [
		9,
		10
	],
	"./footer/footer.js": [
		10,
		11
	],
	"./form/form.js": [
		11,
		12
	],
	"./header/header.js": [
		21,
		13
	],
	"./match-widget/match-widget.js": [
		12,
		14
	],
	"./menu-widget/menu-widget.js": [
		13,
		15
	],
	"./newscontent/newscontent.js": [
		14,
		16
	],
	"./shop-widget/shop-widget.js": [
		15,
		17
	],
	"./sponsors-widget/sponsors-widget.js": [
		17,
		0,
		2
	],
	"./sponsors/sponsors.js": [
		16,
		0,
		3
	],
	"./sponsorspage/sponsorspage.js": [
		18,
		18
	],
	"./sportlink-widget/sportlink-widget.js": [
		19,
		19
	],
	"./text-widget/text-widget.js": [
		20,
		20
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2;
module.exports = webpackAsyncContext;